export const ADMIN = 'ADMIN'
export const USER = 'USER'
export const TEST = 'TEST'

export const ROLES = [ADMIN, USER, TEST]
